module.exports = __webpack_public_path__ + "static/media/async_bulk_post.c0c9047b.svg";